import { useSelector, useDispatch } from 'react-redux';
import FJModal from '../../FJModal';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJReportModal from '../view/FJReportModal.jsx';
import FJActionModal from '../../../../redux/action/FJActionModal.js';
import FJNetworkStore from '../../../../store/FJNetworkStore.js';
import FJMessageStore from '../../../../store/FJMessageStore.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';

const FJReportModalContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const reportModalData = useSelector(state => state.modals.reportModalData);
    const { display, data = {} } = reportModalData;
    const { uid, shareKey } = data;
    const _onCancel = () => {
        dispatch(FJActionModal.hideReportModalAction());
    };

    const _onSubmit = (index, value) => {
        FJNetworkStore.report({
            key: shareKey,
            uid: uid,
            targetType: 'community',
            type: index,
            content: value,
        })
            .then(res => {
                _onCancel();
                FJMessageStore.addMessage(FJLocalStore._('reported-successfully'));
            })
            .catch(err => {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-report'), 'error');
            });
    };

    return (
        <FJModal visible={display}>
            <FJReportModal onCancel={_onCancel} onSubmit={_onSubmit} />
        </FJModal>
    );
};
export default FJReportModalContainer;
